import { Component } from '@angular/core';
import { VTableService } from '@app/directives/_layout/v-table/_services/v-table.service';
import { SortDirection } from '@app/enum/SortDirection';
import { VehicleType } from '@app/enum/VehicleType.enum';
import { IKeyValuePair } from '@app/interfaces/IKeyValuePair';
import { ContextualSpeedingThresholdService } from '@app/services/contextual-speeding-threshold.service';
import { UnitConversionService, UnitConversionType } from '@app/services/unitConversion.service';
import { ContextualSpeedingTab } from '../base/contextual-speeding-tab';
import { ContextualSpeedingVehicleEditorComponent } from '../contextual-speeding-vehicle-editor/contextual-speeding-vehicle-editor.component';
import { ContextualSpeedingThreshold } from '../models/contextual-speeding-threshold';
import './contextual-speeding-by-vehicle.component.scss';

@Component({
    selector: 'contextual-speeding-by-vehicle',
    template: require('./contextual-speeding-by-vehicle.component.html')
})
export class ContextualSpeedingByVehicleComponent 
    extends ContextualSpeedingTab<ContextualSpeedingThreshold, ContextualSpeedingVehicleEditorComponent> {
    vehicleTypes: IKeyValuePair<VehicleType>[] = [];

    constructor(
        public readonly vTableService: VTableService,
        private readonly thresholdService: ContextualSpeedingThresholdService,
        private readonly unitConversionService: UnitConversionService
    ) {
        super(vTableService);
        this.vehicleTypes = this.thresholdService.getAdjustedVehicleTypes();
    }

    async loadData(): Promise<ContextualSpeedingThreshold[]> {
        return await this.thresholdService.getContextualSpeedingThresholds();
    }

    async deleteItem(item: ContextualSpeedingThreshold): Promise<void> {
        await this.thresholdService.deleteContextualSpeedingOverride(item.Id);
    }

    createTable(): void {
        this.columns = [
            {
                header: this.vTableService.createTableHeader({ tKey: "ContextualSpeedingByVehicle.VehicleType" }),
                createCellFunction: item => this.vTableService.createTableCell(this.getVehicleTypeName(item.VehicleType))
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "ContextualSpeedingByVehicle.Calculation" }),
                createCellFunction: item => this.vTableService.createTableCell(this.getCalculationFormatted(item))
            },
            {
                header: this.vTableService.createDateTableHeader({ tKey: 'ContextualSpeedingByVehicle.LastUpdated', sorted: true, sortDirection: SortDirection.Descending }),
                createCellFunction: item => this.vTableService.createDateCell(item.UpdatedTime)
            },
            {
                header: this.vTableService.createDateTableHeader({ tKey: 'ContextualSpeedingByVehicle.Created' }),
                createCellFunction: profile => this.vTableService.createDateCell(profile.CreatedTime)
            },
        ]
    }

    // VehicleType name for Unknown is overriden, this is why
    // we dont use TranslationService.tEnum
    private getVehicleTypeName(type: VehicleType): string {
        const vehicleType = this.vehicleTypes.find(x => x.value === type);
        return vehicleType.displayName;
    }

    private getCalculationFormatted(item: ContextualSpeedingThreshold): string {
        const speedThresholdAllowance = this.unitConversionService.convertToUserUnitWithLabel(
            item.SpeedThresholdAllowanceKph, 
            UnitConversionType.Speed
        );

        const speedThresholdAllowanceNoWhitespace = speedThresholdAllowance.replace(" ", "");
        
        return `${item.SpeedPercentThreshold}% + ${speedThresholdAllowanceNoWhitespace}`;
    }
}